import { useEffect } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import {
  selectIsAuthorized,
  selectIsSessionRequested,
  setupProfile,
} from '@/entities/session';
import { baseApi } from '@/shared/api';
import { ROUTES } from '@/shared/constants';
import { useAppDispatch, useAppSelector } from '@/shared/model';

export function GuestGuard() {
  const dispath = useAppDispatch();
  const isSessionRequested = useAppSelector(selectIsSessionRequested);
  const isAuthorized = useAppSelector(selectIsAuthorized);

  useEffect(() => {
    if (isSessionRequested) {
      return;
    }

    dispath(setupProfile());
  }, [isSessionRequested, dispath]);
  useEffect(() => {
    const { data } = baseApi.auth.onAuthStateChange((event) => {
      if (event === 'SIGNED_IN' && globalThis.document.hidden) {
        globalThis.location.reload();
      }
    });

    return () => {
      data.subscription.unsubscribe();
    };
  }, []);
  if (isAuthorized) {
    return <Navigate to={ROUTES.home} />;
  }

  return <Outlet />;
}
